export default __webpack_public_path__ + "static/media/discover.63e6316b.svg";